export default __webpack_public_path__ + "static/media/VAMLs.c1d65b2a.png";